export default __webpack_public_path__ + "static/media/CORRELATIVO.ec855066.gif";